import { render, staticRenderFns } from "./HotelStatsCell.vue?vue&type=template&id=4aec9b53&scoped=true"
import script from "./HotelStatsCell.vue?vue&type=script&lang=js"
export * from "./HotelStatsCell.vue?vue&type=script&lang=js"
import style0 from "./HotelStatsCell.vue?vue&type=style&index=0&id=4aec9b53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec9b53",
  null
  
)

export default component.exports